import { useEffect, useState } from "react";
import useGetFiles from "./useGetFiles";
import useProveedor from "./useProveedor";

const CONSTANCIA_CUIT = "Constancia de CUIT/CUIL";
const CONSTANCIA_IIBB = "Constancia de IIBB";
const CONSTANCIA_OTRAS = "Otras constancias";

const initialData = {
    [CONSTANCIA_CUIT]: {
        id: 1,
        maxFiles: 1,
        fileList: [],
    },
    [CONSTANCIA_IIBB]: {
        id: 2,
        maxFiles: 1,
        fileList: [],
    },
    [CONSTANCIA_OTRAS]: {
        id: 3,
        maxFiles: 3,
        fileList: [],
    },
};

const initalDataDeepCopy = () => {
    let finalCopy = {};
    const keys = Object.keys(initialData);

    keys.forEach((key) => {
        let fileListCopy = [...initialData[key].fileList];
        finalCopy[key] = { ...initialData[key], fileList: fileListCopy };
    });

    return finalCopy;
};

const useProveedorData = () => {
    const { cuit } = useProveedor();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const [filesToUpload, setFilesToUpload] = useState(initialData);

    const getFiles = useGetFiles();

    useEffect(() => {
        setLoading(true);
        setError(false);
        const request = [
            {
                Key: "APP",
                Value: "Proveedores",
            },
            {
                Key: "CONTEXTO",
                Value: "Constancias",
            },
            {
                Key: "CUIT",
                Value: cuit,
            },
        ];
        getFiles(request)
            .then((files) => {
                let filesToUploadCopy = initalDataDeepCopy();

                files.forEach((file) => {
                    const tipo_constancia = file["subcontexto"];
                    filesToUploadCopy[tipo_constancia].fileList = [
                        ...filesToUploadCopy[tipo_constancia].fileList,
                        file,
                    ];
                });

                setFilesToUpload(filesToUploadCopy);
            })
            .catch((error) => {
                console.log(error);
                setError(true);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [cuit]);

    return {
        filesToUpload,
        loading,
        error,
    };
};
export default useProveedorData;
